<template>
  <div class="layout-header" :class="{ active }">
    <div class="layout-header-content">
      <div class="header-left-wrapper">
        <router-link class="logo-link" to="/">
          <img class="logo" src="@/assets/logo.png" alt="logo" />
        </router-link>
        <div class="logo-divider"></div>
        <span class="logo-description"> 领先的数据能力服务践行者 </span>
      </div>
      <nav class="nav" :class="{ show: showModelMenu }" @click="handleClick">
        <div class="close-bar">
          <span class="close-icon" @click="handleToggle">X</span>
        </div>
        <div
          class="nav-link"
          :class="{
            active: '/home' === parentActiveKey
          }"
        >
          <router-link class="link" to="/"> 首页 </router-link>
        </div>
        <div
          class="nav-link"
          :class="{
            active: '/solution' === parentActiveKey
          }"
        >
          <router-link class="link" to="/solution"> 解决方案 </router-link>
          <div class="dropdown solution">
            <router-link
              v-for="item in solutionList"
              :key="item.path"
              class="dropdown-item"
              :class="{
                active: item.path === activeKey
              }"
              :to="item.path"
            >
              {{ item.title }}
            </router-link>
          </div>
        </div>
        <div
          class="nav-link"
          :class="{
            active: '/product' === parentActiveKey
          }"
        >
          <router-link class="link" to="/product"> 核心产品 </router-link>
          <div class="dropdown service">
            <div class="left">
              <div class="title">公安</div>
              <router-link
                v-for="item in publicSecurityList"
                :key="item.path"
                class="dropdown-item"
                :class="{
                  active: item.path === activeKey
                }"
                :to="item.path"
              >
                {{ item.title }}
              </router-link>
            </div>
            <div class="right">
              <div class="right-top">
                <div class="title">银行</div>
                <router-link
                  v-for="item in bankList"
                  :key="item.path"
                  class="dropdown-item"
                  :class="{
                    active: item.path === activeKey
                  }"
                  :to="item.path"
                >
                  {{ item.title }}
                </router-link>
              </div>
              <div class="right-bottom">
                <div class="title">企业</div>
                <router-link
                  v-for="item in enterpriseList"
                  :key="item.path"
                  class="dropdown-item"
                  :class="{
                    active: item.path === activeKey
                  }"
                  :to="item.path"
                >
                  {{ item.title }}
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div
          class="nav-link"
          :class="{
            active: '/customerCase' === parentActiveKey
          }"
        >
          <router-link class="link" to="/customerCase"> 客户案例 </router-link>
        </div>
        <div
          class="nav-link"
          :class="{
            active: '/service' === parentActiveKey
          }"
        >
          <router-link class="link" to="/service"> 服务支持 </router-link>
        </div>
        <div
          class="nav-link"
          :class="{
            active: '/informationReported' === parentActiveKey
          }"
        >
          <router-link class="link" to="/informationReported">
            资讯报道
          </router-link>
        </div>
        <div
          class="nav-link"
          :class="{
            active: '/attractTalents' === parentActiveKey
          }"
        >
          <router-link class="link" to="/attractTalents">
            招贤纳士
          </router-link>
        </div>
        <div
          class="nav-link"
          :class="{
            active: '/aboutUs' === parentActiveKey
          }"
        >
          <router-link class="link" to="/aboutUs"> 关于科度 </router-link>
        </div>
      </nav>
      <div
        v-if="showModelMenu"
        class="model-menu-back"
        @click="handleToggle"
      ></div>
      <div class="model-menu-icon">
        <img
          class="model-menu-icon-img"
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAWCAYAAAA1vze2AAAACXBIWXMAAAsSAAALEgHS3X78AAAAS0lEQVRIiWP8////fwYaAyZaW8BAL0tYGBgYDtLaEkY6RMkwihO6RbwDrS0ZzYwkAVCcNNLaktHMOPgsGc2Mg88SUJw40tQGBgYGAHGsFCNKTqLNAAAAAElFTkSuQmCC"
          @click="handleToggle"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LayoutHeader',
  data() {
    return {
      active: false,
      showModelMenu: false,
      solutionList: [
        { path: '/solution/1', title: '反诈中心解决方案' },
        { path: '/solution/3', title: '反诈联盟解决方案' },
        { path: '/solution/2', title: '侦查中心解决方案' },
        { path: '/solution/4', title: '警校数据侦查实验室' },
        { path: '/solution/5', title: '防控治理中心解决方案' }
      ],
      publicSecurityList: [
        { path: '/product/1', title: '预警劝阻平台' },
        { path: '/product/2', title: '案件侦办平台' },
        { path: '/product/3', title: '线索侦研平台' },
        { path: '/product/4', title: '自动止付（反制通）' },
        { path: '/product/5', title: '数据智能分析（小刀）' },
        { path: '/product/6', title: '防控治理警务平台' }
      ],
      bankList: [
        { path: '/product/7', title: '安全协作平台' },
        { path: '/product/8', title: '两卡治理小程序' }
      ],
      enterpriseList: [{ path: '/product/9', title: '企业申诉救济' }]
    }
  },
  computed: {
    parentActiveKey() {
      return this.$route.matched[1].path
    },
    activeKey() {
      return this.$route.path
    }
  },
  watch: {},
  methods: {
    toHome() {
      this.$router.push({ path: '/' })
    },
    handleClick(e) {
      if (e.target.tagName === 'A') {
        this.showModelMenu = false
      }
      this.removeBodyOverflow()
    },
    handleToggle() {
      this.showModelMenu = !this.showModelMenu
      if (this.showModelMenu) {
        document.body.style = 'overflow: hidden'
      } else {
        this.removeBodyOverflow()
      }
    },
    removeBodyOverflow() {
      document.body.style = ''
    },
    resize() {
      if (window.innerWidth > 900) {
        this.showModelMenu = false
        this.removeBodyOverflow()
      }
    }
  },
  mounted() {
    if (this.$route.path !== '/home') {
      this.active = true
    } else {
      this.$nextTick(() => {
        setTimeout(() => {
          this.active = true
        }, 1000)
      })
    }
    window.addEventListener('resize', this.resize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize)
  }
}
</script>
<style lang="less" scoped>
.layout-header {
  position: absolute;
  top: -72px;
  height: 72px;
  width: 100%;
  border-bottom: 1px solid #ffffff14;
  opacity: 0;
  z-index: 9999999999;
  // background-color: #1b1a16;
  transition: all 0.3s;
  &.active {
    opacity: 1;
    top: 0;
  }
  .layout-header-content {
    margin: 0 auto;
    padding: 0 10px;
    max-width: 1220px;
    height: 72px;
  }
  .header-left-wrapper {
    display: inline-flex;
    margin-top: 24px;
    height: 24px;
    justify-content: end;
    align-items: end;
    .logo-link {
      height: 24px;
      .logo {
        height: 24px;
        width: auto;
        cursor: pointer;
        vertical-align: middle;
      }
    }

    .logo-divider {
      margin: 0 10px;
      width: 1px;
      height: 24px;
      background-color: #312b2b;
    }
    .logo-description {
      font-size: 12px;
      line-height: 14px;
      color: white;
    }
  }
}
@media screen and (min-width: 1080.02px) {
  .model-menu-icon,
  .model-menu-back {
    display: none;
  }
  .nav {
    float: right;
    height: 72px;
    .close-bar {
      display: none;
    }
    .nav-link {
      position: relative;
      display: inline-block;
      margin-right: 40px;
      height: 100%;
      border-bottom: 3px solid transparent;
      line-height: 72px;
      font-size: 16px;
      transition: border-color 0.3s;
      cursor: pointer;
      &:last-child {
        margin-right: 0;
      }
      &:hover {
        border-color: #0972ab;
        .dropdown {
          opacity: 1;
          pointer-events: all;
        }
      }
      &.active {
        border-color: #d63f42;
        font-weight: 600;
      }
      .link {
        display: block;
        text-decoration: none;
        color: #ffeff0;
        height: 100%;
      }
      .dropdown {
        position: absolute;
        left: 0;
        top: 72px;
        padding: 24px;
        background-color: #1b1a16;
        color: #feeeef;
        opacity: 0;
        pointer-events: none;
        z-index: 9999;
        // transition: opacity 0.3s;
        .dropdown-item {
          display: block;
          margin-bottom: 8px;
          height: 32px;
          font-weight: 400;
          font-size: 16px;
          line-height: 32px;
          letter-spacing: 0%;
          text-align: left;
          text-decoration: none;
          color: #ffeff0;
          &:last-child {
            margin-bottom: 0;
          }
          &.active {
            font-weight: 600;
            color: #d63f42;
          }
        }
      }
      .dropdown.solution {
        width: 220px;
      }
      .dropdown.service {
        display: flex;
        width: 430px;
        justify-content: space-between;
        .right-bottom {
          margin-top: 68px;
          min-width: 160px;
        }
        .title {
          margin-bottom: 10px;
          height: 48px;
          line-height: 48px;
          font-style: 14px;
          color: #d2153d;
        }
      }
    }
  }
}
@media screen and (max-width: 1366px) {
  .layout-header {
    .nav {
      .nav-link {
        .dropdown.service {
          left: auto;
          right: 0;
        }
        .dropdown.solution {
          left: auto;
          right: 0;
        }
      }
    }
  }
}
@media screen and (max-width: 1080px) {
  .model-menu-icon {
    position: fixed;
    display: block;
    top: 24px;
    right: 24px;
    .model-menu-icon-img {
      cursor: pointer;
      filter: drop-shadow(#333333 0 0 2px);
    }
  }
  .layout-header {
    .model-menu-back {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.3);
      backdrop-filter: blur(5px);
      z-index: 1;
    }
    .nav {
      position: fixed;
      right: 0;
      top: 0;
      height: 100%;
      width: 200px;
      background-color: #ffffff;
      overflow: auto;
      z-index: 2;
      transform: translateX(100%);
      &.show {
        transition: transform 0.3s;
        transform: translateX(0);
      }
      .dropdown {
        pointer-events: auto !important;
      }
      .close-bar {
        display: block;
        height: 72px;
        padding: 0 16px;
        line-height: 72px;
        text-align: right;
        font-weight: 600;
        .close-icon {
          cursor: pointer;
        }
      }
      .nav-link {
        padding-left: 16px;
        line-height: 32px;
        &.active {
          .link {
            font-weight: 600;
            color: #d63f42;
          }
        }
        .link {
          color: #1b1a16;
          text-decoration: none;
          font-weight: 600;
          &:hover {
            text-decoration: underline;
          }
        }
        .dropdown {
          padding-left: 16px;
          .title {
            font-weight: 600;
            color: #1b1a16;
          }
          .dropdown-item {
            display: block;
            color: #1b1a16;
            text-decoration: none;
            &:hover {
              text-decoration: underline;
            }
            &.active {
              font-weight: 600;
              color: #d63f42;
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 500px) {
  .layout-header {
    .header-left-wrapper {
      flex-direction: column;
      align-items: start;
      justify-content: center;
    }
    .logo-divider {
      display: none;
    }
    .logo-description {
      margin-top: 4px;
    }
    .nav {
      width: 100%;
    }
  }
}
</style>
